"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const typography_1 = __importDefault(require("../../elements/typography"));
const BottomNav = (props) => {
    const { items, linkComponent, onChange, value } = props;
    return (react_1.default.createElement(material_1.BottomNavigation, { showLabels: true, onChange: onChange, value: value }, items.map((item, i) => (react_1.default.createElement(material_1.BottomNavigationAction, { key: i, component: linkComponent, to: item.url, label: react_1.default.createElement(typography_1.default, { variant: "overline" }, item.label), icon: item.icon })))));
};
exports.default = BottomNav;
